import { Bank } from 'types';

import { createCrudApi } from './crud.api';

export const banksApi = createCrudApi<Bank>('/banks');
